import { AccountService } from './../../../services/account.service';
import { InspectionService } from './../../../inspection/shared/services/inspection.service';
import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FileUploadModel } from '../file-upload.model';
import { SessionQuery } from '../state/session.query';
import { NotificationService } from '../../services/notification.service';
import {
  parseUploadApiError,
  validatePdfFileBeforeUpload
} from '../../helpers/pdf-upload-validator';


@Component({
  selector: 'app-upload-button',
  templateUrl: './upload-button.component.html',
  styleUrls: ['./upload-button.component.scss']
})
export class UploadButtonComponent implements OnInit {

  @Input() fileUploadModel: FileUploadModel;
  @Output() fileUploaded = new EventEmitter<any>();
  @Input() isEditMode : boolean;

  isUploading = false; // used to show loading progress on the component

  showFileName = false;

  constructor(private sharedService: InspectionService,  private sessionQuery: SessionQuery,
	private accountService:AccountService, private notificationService: NotificationService,
	private cdr: ChangeDetectorRef,
	) {
  }

  ngOnInit(): void {
	  console.log("inside upload button")
  }

  handleFileInput(target: any) {
    const file$ = target.files.item(0);
    if (!file$ || !this.fileUploadModel) {
      return;
    }

    const maxBytes = 25 * 1024 * 1024;
    validatePdfFileBeforeUpload(file$, maxBytes).then(validationError => {
      if (validationError) {
        this.notificationService.error('Upload', validationError);
        return;
      }

      const userId = this.accountService.getUserData().id;
      this.fileUploadModel = {
        file: file$,
        referenceId: this.fileUploadModel?.referenceId,
        tempFolderName: this.accountService.getUserData().username,
        tempFileName: this.fileUploadModel?.tempFileName,
        UserId: userId,
        ApplicationId: null,
        fileName: file$.name,
        fileType: file$.type,
        originalFileName: this.fileUploadModel?.originalFileName,
      };
      this.upload();
    }).catch(() => {
      this.notificationService.error('Upload', 'Unable to read the selected file.');
    });
  }

  upload() {
    this.fileUploadModel.filePath = '-';
    this.isUploading = true;
    this.sharedService.uploadFile(this.fileUploadModel).subscribe((result) => {
      if (!result) {
        this.notificationService.error('Upload', 'Unable to upload file');
      } else {
        this.fileUploaded.emit(result);
        this.showFileName = true;
      }
      this.isUploading = false;
      this.cdr.detectChanges();
    }, (err) => {
      const message = err?.error?.Message || parseUploadApiError(err?.error ? JSON.stringify(err.error) : '', err?.status || 0);
      this.notificationService.error('Upload', message);
      this.isUploading = false;
      this.cdr.detectChanges();
    });
  }
}
